// Formats a timestamp as a short relative string ("2 hours ago"). Used to
// turn real created_at/contributed_at fields into a human-readable feed
// instead of hardcoding a display string.
export function timeAgo(dateInput) {
  if (!dateInput) return '';
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';

  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';

  const units = [
    { label: 'year', secs: 31536000 },
    { label: 'month', secs: 2592000 },
    { label: 'day', secs: 86400 },
    { label: 'hour', secs: 3600 },
    { label: 'minute', secs: 60 }
  ];

  for (const unit of units) {
    const count = Math.floor(seconds / unit.secs);
    if (count >= 1) {
      return `${count} ${unit.label}${count > 1 ? 's' : ''} ago`;
    }
  }
  return 'just now';
}
